"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHevyWebsocketMessage = void 0;
const isHevyWebsocketMessage = (message) => {
    return !!message && typeof message.type === 'string';
};
exports.isHevyWebsocketMessage = isHevyWebsocketMessage;
